import { render, staticRenderFns } from "./OverviewView.vue?vue&type=template&id=aa0c27b0&scoped=true"
import script from "./OverviewView.vue?vue&type=script&lang=ts"
export * from "./OverviewView.vue?vue&type=script&lang=ts"
import style0 from "./OverviewView.vue?vue&type=style&index=0&id=aa0c27b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0c27b0",
  null
  
)

export default component.exports